var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$currentUser.role != "admin"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("span", { staticClass: "alert-danger" }, [
            _vm._v("У вас нет доступа к этой странице.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$currentUser.role == "admin"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12" }, [
              !_vm.isMobile
                ? _c(
                    "div",
                    [
                      _c("b-table", {
                        attrs: {
                          hover: "",
                          responsive: "",
                          bordered: "",
                          small: "",
                          items: _vm.logs,
                          fields: _vm.fields,
                          "no-local-sorting": "",
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "sort-changed": function($event) {
                            return _vm.getLogs(1, $event, _vm.search)
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(description)",
                              fn: function(row) {
                                return [
                                  row.item.description == "deleted"
                                    ? _c("span", [_vm._v("Удалено")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.item.description == "updated"
                                    ? _c("span", [_vm._v("Обновлено")])
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell(actions)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn btn-primary",
                                      staticStyle: {
                                        color: "#fff",
                                        "background-color": "#007dcc",
                                        "border-color": "#007dcc"
                                      },
                                      attrs: {
                                        size: "sm",
                                        href: "/log/" + row.item.id
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-eye"
                                      })
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1734151368
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile
                ? _c(
                    "div",
                    [
                      _c("b-table", {
                        attrs: {
                          hover: "",
                          responsive: "",
                          bordered: "",
                          stacked: "",
                          small: "",
                          items: _vm.logs,
                          fields: _vm.fields,
                          "no-local-sorting": "",
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "sort-changed": function($event) {
                            return _vm.getLogs(1, $event, _vm.search)
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(description)",
                              fn: function(row) {
                                return [
                                  row.item.description == "deleted"
                                    ? _c("span", [_vm._v("Удалено")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.item.description == "updated"
                                    ? _c("span", [_vm._v("Обновлено")])
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell(actions)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn btn-primary",
                                      staticStyle: {
                                        color: "#fff",
                                        "background-color": "#007dcc",
                                        "border-color": "#007dcc"
                                      },
                                      attrs: {
                                        size: "sm",
                                        href: "/log/" + row.item.id
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-eye"
                                      })
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1734151368
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-5" }, [
              _c("div", { attrs: { role: "status", "aria-live": "polite" } }, [
                _vm._v("Всего записей: " + _vm._s(_vm.pager.total))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-7" }, [
              _c("div", { staticClass: "float-right" }, [
                _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
                  _c(
                    "ul",
                    { staticClass: "pagination justify-content-center" },
                    [
                      _c("b-pagination", {
                        attrs: {
                          size: "sm",
                          "total-rows": _vm.pager.total,
                          "per-page": _vm.pager.per_page
                        },
                        on: {
                          change: function($event) {
                            return _vm.getLogs(
                              $event,
                              { sortBy: _vm.sortBy, sortDesc: _vm.sortDesc },
                              _vm.search
                            )
                          }
                        },
                        model: {
                          value: _vm.pager.current_page,
                          callback: function($$v) {
                            _vm.$set(_vm.pager, "current_page", $$v)
                          },
                          expression: "pager.current_page"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Логи")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d8a0db4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d8a0db4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/Logs.vue
// module id = 1033
// module chunks = 0